import { useEffect, useRef, useState, useCallback, useMemo } from 'react'
import {
    Linking,
    BackHandler,
    Text,
    Animated,
    Image,
    View,
    Platform,
    ScrollView,
    Pressable,
} from 'react-native'
import { fetchUserAttributes } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import { getPlatform, platformSelect } from '../../utils/platformUtils'
import { useDispatch } from 'react-redux'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { AntDesign, Feather, Ionicons } from '@expo/vector-icons'
import * as Application from 'expo-application'
import * as SecureStore from 'expo-secure-store'
import * as Crypto from 'expo-crypto'
import { v4 as uuidv4 } from 'uuid'
import NetInfo from '@react-native-community/netinfo'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { useFooterApp } from '../../redux/zustand/footerAppStore'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import { getAppVersion } from '../customUtils/AppConstants'
import {
    openDB,
    getGlobalVersion,
    updateGlobalVersion,
    addUser,
    getUser,
} from '../../db/indexDB'
import styles from './TabsNavigationStyles'
import themes from '../../../theme'
import BenefitsHome from '../benefits/benefitsHome'
import PostsList from '../posts/PostsList'
import LearningHome from '../learning/learningHome'
import Portfolio from '../portfolio/Portfolio'
import { Schedule } from '../stores/Schedule'
import { VouchersScreen } from '../vouchers/VouchersScreen'
import { getConection, getData } from '../appBar/context/HeaderContext'
import { usePushNotification } from '../../config/usePushNotifications'
import { generateWebSocketUrl } from '../../utils/webSocketUtils'
import { useUrlWebSocket } from '../../redux/zustand/webSocketUrl'
import { getLocation } from '../appBar/context/LocationContext'
import { TrackingServices } from '../../../database/tracking.database'
import { UserServices } from '../../../database/user.database'
import { Loader } from '../customUtils/Components/Loader'
import { request_get_user_profile } from '../../services/user.services'
import { WiseScreen } from '../stores/WiseScreen'
import { BottomSheetAlert, FullSheetAlert } from '../modals/BottomSheetAlert'
import {
    getDeviceInfo,
    validateConnectionNetwork,
    getAuthToken,
} from '../../utils/functions.utils'
import { CreateScheduleModerator } from '../stores/CreateScheduleModerator'
import { MyAdvance } from '../myAdvance/MyAdvance'
import { PostsServices } from '../../../database/posts.database'
import { save_survey_request } from '../learning/services'
import { ScheduleDistributor } from '../stores/ScheduleDistributor'
import { eventEmitter } from '../../utils/functions.utils'
import { onClickRedirect } from '../posts/Go_to'
import { Link, useIsFocused, useNavigation } from '@react-navigation/native'
import { useSchedule } from '../stores/hooks/useSchedule'
import { LoginBiometricsStorage } from '../../utils/LoginBiometricsStorage'
import { StorageAdapter } from '../../utils/AsyncStorage'
import { ASYNC_STORAGE_KEYS } from '../stores/constants/constants.storage'
import { TriviaScreen } from '../trivia/TriviaScreen'
import { Gamification } from '../gamification/Gamification'
import { RankingScreen } from '../ranking/Ranking'
import { getLanguageFile } from '../../translations/i18n'
import { useDataPendingSendStore } from '../../redux/zustand/dataPendingSendStore'
import { useBackgroundTask } from '../../hooks/useBackgroundTask'
import { schedulesServices } from '../../../database/schedules.database'
import { request_save_schedules_activities } from '../../services/schedule.services'
import { WEBSOCKET_TYPES } from '../../utils/Constants'
import { request_save_trackings } from '../../services/tracking.services'
import Constants from 'expo-constants'
import { DotiScreen } from '../doti/DotiScreen'
import { cleanupLocalStores } from '../../../db-sqlite/repositories/schedule.repository'
import { ProfileScreen } from '../profile/ProfileScreen'
import { HARDCODE_DOTI } from '@/config/config'
import { DotiFooter } from './DotiFooter'
import { DashboardWeb } from '../customUtils/Components/DashboardWeb'
import { AdvancesScreen } from '../advances/AdvancesScreen'

const Tab = createBottomTabNavigator()
const languageFile = getLanguageFile()

const TIME_INTERVAL_FAST = 10000 // 10s
const TIME_INTERVAL_SLOW = 30000 // 30s

// Variables globales para persistir el estado entre remontajes
let globalFirstBatchReady = false
let globalFirstScreenReady = false
let globalIsLoading = true

// Definición del tab hardcodeado de Doti
// id dots 691f2f124b087e7c3279b40f
const dotiData = {
    _id: '69b94cecb9fe5767f7e1671d',
    active: true,
    icon: '',
    index: 14,
    label: 'Doti',
    name: 'Doti',
    nav: false,
    section: false,
}

/**
 * Helper: Agrega/remueve el tab de Doti según HARDCODE_DOTI
 * IMPORTANTE: NO persiste en DB, solo modifica el array en memoria
 * @param {Array} footerArray - Array del footer a verificar/modificar
 * @param {string} source - Origen de la llamada (para logs)
 * @returns {Array} Footer con doti agregado o removido según configuración
 */
const ensureDotiInFooter = (footerArray, source = 'unknown') => {
    if (!Array.isArray(footerArray)) {
        console.warn(
            `[ensureDotiInFooter][${source}] footerArray no es un array:`,
            typeof footerArray,
        )
        return footerArray
    }

    const hasDoti = footerArray.some(
        (item) => item._id === dotiData._id || item.label === 'Doti',
    )

    if (HARDCODE_DOTI) {
        // Si debe estar y no está, agregarlo
        if (!hasDoti) {
            console.log(
                `✅ [ensureDotiInFooter][${source}] HARDCODE_DOTI=true → Agregando doti (total: ${footerArray.length + 1})`,
            )
            return [...footerArray, { ...dotiData }]
        }
        console.log(
            `ℹ️  [ensureDotiInFooter][${source}] HARDCODE_DOTI=true → Doti ya existe (total: ${footerArray.length})`,
        )
        const filteredArray = footerArray.filter((item) => item.label !== 'Doti')
        if (filteredArray.length < footerArray.length) {
            console.log(
                `🔄 [ensureDotiInFooter][${source}] HARDCODE_DOTI=true → Removiendo Doti del backend y usando hardcoded`,
            )
            return [...filteredArray, { ...dotiData }]
        }
        return footerArray
    } else {
        // Si NO debe estar pero está, removerlo (por _id o label)
        if (hasDoti) {
            console.log(
                `🗑️ [ensureDotiInFooter][${source}] HARDCODE_DOTI=false → Removiendo doti (total: ${footerArray.length - 1})`,
            )
            return footerArray.filter(
                (item) => item._id !== dotiData._id && item.label !== 'Doti',
            )
        }
        console.log(
            `ℹ️  [ensureDotiInFooter][${source}] HARDCODE_DOTI=false → Doti no presente (total: ${footerArray.length})`,
        )
        return footerArray
    }
}

function MyTabs() {
    // Guard interno de error en web para evitar crash por BottomTabView cuando height=0 o layout inconsistente
    const [internalError, setInternalError] = useState(null)
    const safeRender = (children) => {
        if (Platform.OS === 'web') {
            try {
                return children
            } catch (err) {
                console.error('[MyTabs][safeRender] error atrapado:', err)
                setInternalError(err)
                return null
            }
        }
        return children
    }
    // Flujo unificado: web ya no hace early return para permitir inicialización de footer_app y navegación consistente.
    const [isLoading, setIsLoading] = useState(globalIsLoading)
    const [firstBatchReady, setFirstBatchReady] = useState(globalFirstBatchReady)
    const [firstScreenReady, setFirstScreenReady] = useState(globalFirstScreenReady)
    const [hasLocalPosts, setHasLocalPosts] = useState(false)
    const [footerDeadlineExpired, setFooterDeadlineExpired] = useState(false)
    const navigation = useNavigation()
    const footer_app = useFooterApp((state) => state.footer_app)
    const setFooterApp = useFooterApp((state) => state.setFooterApp)
    const setHavePendingData = useDataPendingSendStore(
        (store) => store.setHavePendingData,
    )
    const setPendingsSend = useDataPendingSendStore((store) => store.setPendingsSend)
    const setProgress = useDataPendingSendStore((store) => store.setProgress)
    const progressTotalModal = useDataPendingSendStore(
        (store) => store.progressTotalModal,
    )
    const setProgressTotalModal = useDataPendingSendStore(
        (store) => store.setProgressTotalModal,
    )
    const setShowProfileNav = useFooterApp((state) => state.setShowProfileNav)

    // Variable local para mantener el total inicial persistente
    const totalInicial = useRef(0)
    const ultimosPendientes = useRef(0)
    const progressAnimation = useRef(null) // Para controlar la animación
    const isExecutingSendPending = useRef(false) // Flag para evitar ejecuciones simultáneas
    const currentIntervalRef = useRef(TIME_INTERVAL_SLOW) // Ref para el intervalo actual

    const { setDeviceId, token_notification } = useDeviceStore()
    const { expoPushToken, notification } = usePushNotification()
    const { setUrlWebSocket } = useUrlWebSocket()
    const [user, setUser] = useState(undefined)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const { userLat, userLng, updateLocation, lastUpdateCoorsUser } = getLocation()
    const { setCurrentFooterRoute, footerRoute } = getData()
    const { sendPendingConnection, downloadPendingPS } = useSchedule({
        withEffect: false,
    })
    const isFocused = useIsFocused()

    // Hook para tarea de segundo plano con reinicio de flag inicial
    const backgroundTask = useCallback(async () => {
        // Reiniciar flag solo en la primera ejecución
        if (!backgroundTask._flagRestarted) {
            await StorageAdapter.setItem(
                ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES,
                'false',
            )
            backgroundTask._flagRestarted = true
        }

        await sendPendingConnectionMain()
    }, [])

    // Usar el hook de tarea de segundo plano
    const { executeNow, isRunning } = useBackgroundTask(backgroundTask, {
        interval: currentIntervalRef.current,
        runOnMount: true,
        runOnAppFocus: true,
        enabled: true,
    })

    const setColor = (focus) => {
        let color = focus ? themes.colors.colorPrimary : 'black'
        return color
    }
    const setColorBenefits = (focus) => {
        let color = focus ? themes.colors.alert : 'black'
        return color
    }
    const getDeviceId = async () => {
        try {
            const platformOS = getPlatform().OS
            if (platformOS === 'android') {
                try {
                    return Application.getAndroidId() // sdk 54
                } catch (error) {
                    console.error('43 error al obtener android id: ', error)
                }
            } else if (platformOS === 'web') {
                let deviceId = localStorage.getItem('deviceId')

                if (!deviceId) {
                    deviceId = Crypto.randomUUID()
                    localStorage.setItem('deviceId', deviceId)
                }
                return deviceId
            } else {
                let deviceId
                try {
                    let uuid = uuidv4()
                    let fetchUUID = await SecureStore.getItemAsync('secure_deviceid')

                    if (fetchUUID) {
                        uuid = fetchUUID
                    } else {
                        await SecureStore.setItemAsync('secure_deviceid', uuid)
                    }

                    deviceId = uuid
                } catch (error) {
                    console.log('🚀 ~ getDeviceId ~ error:', error)
                }
                return deviceId
            }
        } catch (error) {
            console.error('58 🚀 ~ getDeviceId ~ error:', error)
        }
    }
    // Eliminado hiddenFooterStyle adelantado (usaba shouldShowFooter antes de declararse) para evitar ReferenceError.
    const get_access_token = async (deviceId, token) => {
        // console.log('[TabsNavigation][get_access_token] START deviceId=', deviceId)
        try {
            let retry = 0
            let timeout = 5 //segundos

            const netInfoState = await NetInfo.fetch()

            let data
            const database = await openDB()
            const currentGlobalVersion = await getGlobalVersion(database, 'user')
            let user_db = await getUser(database)

            let res_get_footer_app = await UserServices.getFooterApp()
            const currentFooterFromStore = useFooterApp.getState().footer_app

            const footerAlreadySet =
                currentFooterFromStore && currentFooterFromStore.length > 0

            if (res_get_footer_app && res_get_footer_app.length > 0) {
                if (footerAlreadySet) {
                    // Verificar estado actual vs deseado del doti en store
                    const storeHasDoti = currentFooterFromStore.some(
                        (item) => item._id === dotiData._id,
                    )
                    const shouldHaveDoti = HARDCODE_DOTI

                    if (storeHasDoti !== shouldHaveDoti) {
                        const updatedFooter = ensureDotiInFooter(
                            currentFooterFromStore,
                            'STORE_SYNC',
                        )
                        setFooterApp(updatedFooter)
                    } else {
                        console.log(
                            '✅ [get_access_token] Footer en store correcto según config',
                        )
                    }
                } else {
                    // Primera carga: aplicar doti solo en memoria (no persistir en DB)
                    const footerToSet = ensureDotiInFooter(
                        res_get_footer_app,
                        'INITIAL_LOAD',
                    )
                    eventEmitter.emit('buttonsUpdated')
                    setFooterApp(footerToSet)
                }
            } else {
                console.log(
                    '⚠️  [get_access_token] Sin footer local, esperando respuesta del backend',
                )
                retry = 2
                timeout = 120
            }
            if (user_db) {
                setUser(user_db)
                setUrlWebSocket(user_db.ws_url || null)
                // console.log('LOG INTERNO USER?', user_db)
                // if (user_db && user_db.image_splash) {
                //     console.log('🚀 ~ useEffect ~ user.image_splash', user_db.image_splash)
                //     let l = await config2ndSplash(user_db.image_splash, netInfoState.isConnected)
                //     if (l) {
                //         eventEmitter.emit('showSecondarySplash', user_db.image_splash)
                //     }
                // }
            }
            // En web, isInternetReachable puede ser null al inicio - lo tratamos como true
            if (
                netInfoState.isConnected &&
                netInfoState.isInternetReachable !== false
            ) {
                // Usar getAuthToken con circuit breaker; si no hay token, mantener local y salir
                let authToken = await getAuthToken('tabs_get_access_token')
                if (!authToken) {
                    console.warn(
                        '[TabsNavigation][get_access_token] no authToken; keeping local footer only',
                    )
                    // console.log('[TabsNavigation][get_access_token] Completed')
                    return
                }
                const device_param = {
                    device_key: deviceId,
                    token_notification: token,
                    isLogin: true,
                }
                const headersParam = {
                    // version:
                    //     res_get_footer_app && res_get_footer_app.length > 0
                    //         ? currentGlobalVersion
                    //         : null,
                    version: null, // Desactivamos version para forzar siempre footer actualizado desde backend
                    device_key: deviceId,
                    device: JSON.stringify(device_param),
                    app_version: getAppVersion(), //expo.expo.android.versionCode.toString(),
                    system: getPlatform().OS,
                    deviceInfo: JSON.stringify(getDeviceInfo()),
                }

                // console.log('[TabsNavigation][get_access_token] request_get_user_profile -> headers.version:', headersParam.version)
                data = await request_get_user_profile({
                    authToken,
                    headersParam,
                    retry,
                    timeout,
                    useCache: false,
                })
                // console.log('[TabsNavigation][get_access_token] profile status:', data?.status)

                const currentFooter = useFooterApp.getState().footer_app
                const shouldUpdateFooter =
                    !currentFooter || currentFooter.length === 0

                if (
                    data?.single?.footer_data &&
                    data.single.footer_data.length > 0 &&
                    shouldUpdateFooter
                ) {
                    console.log(
                        '🌐 [get_access_token] Footer recibido del backend:',
                        data.single.footer_data.length,
                        'items',
                    )

                    // ✅ Agregar doti ANTES de guardar en DB y store
                    let footerWithDoti = ensureDotiInFooter(
                        data.single.footer_data,
                        'BACKEND',
                    )

                    try {
                        // Guardar en DB SIN doti (solo datos originales del backend)
                        await UserServices.updateFooter(data.single.footer_data)
                        await new Promise((resolve) => setTimeout(resolve, 100))

                        const savedFooter = await UserServices.getFooterApp()
                        console.log(
                            `🔍 [get_access_token] Guardado en DB: ${savedFooter?.length || 0} items`,
                        )
                    } catch (error) {
                        console.error(
                            '[get_access_token] ❌ updateFooter ERROR:',
                            error,
                        )
                    }

                    // Agregar doti SOLO en memoria para el store (no persistir en DB)
                    const footerForStore = ensureDotiInFooter(
                        data.single.footer_data,
                        'BACKEND_TO_STORE',
                    )
                    setFooterApp(footerForStore)
                    res_get_footer_app = footerForStore
                    eventEmitter.emit('buttonsUpdated')
                } else if (
                    data?.single?.footer_data &&
                    data.single.footer_data.length > 0
                ) {
                    await UserServices.updateFooter(data.single.footer_data)
                    await new Promise((resolve) => setTimeout(resolve, 100))
                    const savedFooter = await UserServices.getFooterApp()
                    setFooterApp(savedFooter)

                    // Verificar estado actual vs deseado del doti
                    const storeHasDoti = savedFooter.some(
                        (item) => item._id === dotiData._id,
                    )
                    const shouldHaveDoti = HARDCODE_DOTI

                    if (storeHasDoti !== shouldHaveDoti) {
                        const updatedFooter = ensureDotiInFooter(
                            savedFooter,
                            'BACKEND_SYNC',
                        )
                        setFooterApp(updatedFooter)
                    }
                } else {
                    console.warn(
                        '⚠️  [get_access_token] NO footer_data en respuesta del backend',
                    )
                }

                // if (imageSplash) {
                //     console.log('🚀 ~ useEffect ~ user.image_splash', imageSplash)
                //     let l = await config2ndSplash(imageSplash, netInfoState.isConnected)
                //     if (l) {
                //         eventEmitter.emit('showSecondarySplash', imageSplash)
                //     }
                // }
                if (
                    data &&
                    data.single &&
                    data.single.lock &&
                    data.single.lock.lock_status
                ) {
                    //si tengo que mostrar el modal de bloqueo/act.
                    const title = data.single.lock.title
                    const description = data.single.lock.message
                    let button = data?.single?.lock?.button_goto_update_text
                    let buttonDissmis = data?.single?.lock?.button_close
                    const goto_url = data?.single?.lock?.update_link ?? ''
                    const type =
                        data.single.lock.type == 'restrictive' ||
                        data.single.lock.type == 'maintenance'
                            ? false
                            : true // si es o no restrictive
                    const icon = data.single.lock.icon
                        ? { uri: data.single.lock.icon }
                        : require('../../../assets/appInMaintenance.png')

                    // Web guard: no mostrar modal de actualización en web
                    if (Platform.OS === 'web') {
                        // Si el lock es de tipo "update" o trae un update_link/botón de update, lo ignoramos en web
                        const looksLikeUpdate =
                            (typeof button === 'string' &&
                                button.toLowerCase().includes('actualiz')) ||
                            (typeof title === 'string' &&
                                title.toLowerCase().includes('actualiz')) ||
                            (typeof description === 'string' &&
                                description.toLowerCase().includes('actualiz')) ||
                            (typeof goto_url === 'string' && goto_url.length > 0)

                        if (looksLikeUpdate) {
                            // console.log('[TabsNavigation][get_access_token] Skipping update lock modal on web')
                            // No abrir BottomSheet ni bloquear la UI en web
                            // Continuamos sin mostrar nada para no interferir con la experiencia web
                            return
                        }
                    }

                    let goto = async () => {
                        // Linking.openURL(goto_url)
                        if (goto_url.startsWith('http')) {
                            let url = goto_url
                            if (goto_url.includes('${token}')) {
                                url = url.replace('${token}', authToken)
                            }
                            if (goto_url.includes('${dni}')) {
                                let dni = ''
                                if (data?.single?.user_data?.dni) {
                                    dni = data.single.user_data.dni
                                } else {
                                    const user = await getUser(database)
                                    dni = user.dni
                                }
                                url = url.replace('${dni}', dni)
                            }

                            Linking.openURL(url)
                        } else {
                            await onClickRedirect(
                                { type: 'interno', path: goto_url },
                                navigation,
                                undefined,
                                undefined,
                            ).then(() => {
                                closeBottomSheet(true)
                            })
                        }
                    }
                    let snap = null
                    if (data.single.lock.type === 'maintenance') {
                        // Si es mantenimiento, cierra la app
                        button = null
                        buttonDissmis = null
                        snap = ['100%']
                    } else if (!type) {
                        // Si es restrictivo, solo un botón
                        goto = async () => {
                            Linking.openURL(goto_url)
                        }
                    }
                    console.log(
                        'IMAGEN; ICONO; TITULO; DESC; TYPE',
                        icon,
                        title,
                        description,
                        data.single.lock.type,
                    )

                    // Si el lock es restrictivo, el usuario no debe poder
                    // cerrar el modal con el botón "back" nativo de Android
                    let restrictiveBackHandler = null
                    if (data.single.lock.type === 'restrictive') {
                        restrictiveBackHandler = BackHandler.addEventListener(
                            'hardwareBackPress',
                            () => true,
                        )
                    }

                    openBottomSheet(
                        <FullSheetAlert
                            image={icon}
                            title={title}
                            desc={description}
                            buttonGoto={button}
                            button={buttonDissmis}
                            closeBottomSheet={(i) => {
                                if (restrictiveBackHandler) {
                                    restrictiveBackHandler.remove()
                                    restrictiveBackHandler = null
                                }
                                closeBottomSheet(i)
                            }}
                            goto={goto}
                        />,
                        snap,
                        type,
                    )
                }
                if (data && data?.status === 1) {
                    try {
                        const ws_url = generateWebSocketUrl(
                            data.single.user_data.name_group,
                            data.single.user_data._id,
                            deviceId,
                        )
                        let user_data = {
                            ...data.single.user_data,
                            ws_url: ws_url,
                            delete_active: data.single.delete_active,
                            lenguage: data.single.user_data?.lenguage ?? '',
                            languages: data.single.languages ?? [],
                            login: true,
                            cognito_id: null,
                            showClearCacheButton:
                                data.single.showClearCacheButton ?? false,
                        }
                        if (userLat && userLng && lastUpdateCoorsUser) {
                            user_data = {
                                ...data.single.user_data,
                                ws_url: ws_url,
                                delete_active: data.single.delete_active,
                                lat: userLat,
                                lng: userLng,
                                login: true,
                                cognito_id: null,
                                last_update_coords: lastUpdateCoorsUser,
                                showClearCacheButton:
                                    data.single.showClearCacheButton ?? false,
                            }
                        }
                        let biometricMail = user_data.email || ''
                        setUrlWebSocket(ws_url)
                        const { email, phone } =
                            await getEmailPhoneAttributes(user_data)

                        user_data = {
                            ...user_data,
                            email: email,
                            phone: phone,
                            phone_verified: phone ? user_data.phone_verified : false,
                            email_verified: email ? user_data.email_verified : false,
                        }

                        await addUser(database, user_data)
                        const user_name = user_data.name + ' ' + user_data.last_name
                        const updateDataUserLoginBiometric = {
                            avatar: user_data.avatar ?? '',
                            email: biometricMail ?? '',
                            user_name: user_name.trim() ?? '',
                            isVisible: true,
                        }
                        await LoginBiometricsStorage.updateDataBiometricsUser(
                            user_data.user_name,
                            updateDataUserLoginBiometric,
                        )

                        if (data && data.image_splash) {
                        }
                        setUser(user_data)
                        user_db = user_data
                        // if (user_data && user_data.image_splash) {
                        //     eventEmitter.emit('showSecondarySplash', user_data.image_splash)
                        // }
                    } catch (error) {
                        console.log('🚀 ~ data.single.data.forEach ~ error:', error)
                    }
                    let version_update = data.single.user_data.data_version
                        ? data.single.user_data.data_version
                        : 0
                    await updateGlobalVersion(database, 'user', version_update)
                }
            } else {
                console.log(
                    '[TabsNavigation][get_access_token] No internet connection - skipping backend request',
                )
            }
            if (res_get_footer_app && res_get_footer_app.length == 0) {
                console.warn(
                    '[TabsNavigation][get_access_token] footer_app stays EMPTY after profile fetch',
                )
            }

            console.log('[TabsNavigation][get_access_token] Completed')

            // dispatch(setAuthToken(authToken))
        } catch (error) {
            console.error('[TabsNavigation][get_access_token] FATAL ERROR:', error)
        }
    }

    const getEmailPhoneAttributes = async (user_data) => {
        let emailAttr = user_data['email'] || null
        let phoneAttr = user_data['phone_number'] || null

        try {
            const userAttributes = await fetchUserAttributes()

            emailAttr = userAttributes['email'] || null
            phoneAttr = userAttributes['phone_number'] || null
        } catch (error) {
            console.error('Error fetching user attributes:', error)
        }

        return {
            email: emailAttr,
            phone: phoneAttr,
        }
    }
    const showModalConnection = async () => {
        console.log(
            '--------------------------------ejecuto modal de conexion--------------------------------',
        )
        const button = languageFile.accept
        const title = languageFile.modal_not_connected
        const desc = languageFile.modal_not_connected_message

        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/loginError.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() => closeBottomSheet(true)}
            />,
        )
    }
    const handleClickTracking = async (type_interaction, table) => {
        if (user != undefined) {
            const netInfoState = await NetInfo.fetch()
            if (netInfoState.isConnected && netInfoState.isInternetReachable) {
                TrackingServices.addTracking(user['_id'], type_interaction, table)
            } else {
                const type_interaction_offline = `${type_interaction}_offline`
                TrackingServices.addTracking(
                    user['_id'],
                    type_interaction_offline,
                    table,
                )
            }
        } else {
            console.log('user: ', user)
        }
    }

    const getCantDataPending = (tablesPending) => {
        try {
            if (!tablesPending && Object.values(tablesPending).length == 0) {
                return 0
            }
            const cantPending = Object.values(tablesPending).reduce((acc, value) => {
                if (typeof value === 'number' && value > 0) {
                    acc += value
                }
                return acc
            }, 0)

            // console.log('cantPending => ', cantPending)

            return cantPending || 0
        } catch (error) {
            console.error('Error en getCantDataPending:', error)
            return 0
        }
    }

    const animateProgressTo = (targetPercentage, currentPercentage = 0) => {
        // console.log('🎬 Iniciando animación de progreso:', currentPercentage, '→', targetPercentage)

        // Limpiar animación anterior si existe
        if (progressAnimation.current) {
            clearInterval(progressAnimation.current)
        }

        // Si la diferencia es pequeña (menos de 30%), no animar
        if (Math.abs(targetPercentage - currentPercentage) < 30) {
            setProgress(targetPercentage)
            return
        }

        let currentProgress = currentPercentage
        const increment =
            targetPercentage > currentProgress
                ? Math.ceil((targetPercentage - currentProgress) / 10) // Incrementos de ~10%
                : Math.floor((targetPercentage - currentProgress) / 10)

        progressAnimation.current = setInterval(() => {
            if (
                Math.abs(currentProgress - targetPercentage) <= Math.abs(increment)
            ) {
                // Llegamos al target
                setProgress(targetPercentage)
                clearInterval(progressAnimation.current)
                progressAnimation.current = null
                // console.log('🎬 Animación completada en:', targetPercentage + '%')
            } else {
                // Continuar incrementando
                currentProgress += increment
                setProgress(Math.max(0, Math.min(100, currentProgress)))
                // console.log('🎬 Progreso animado:', currentProgress + '%')
            }
        }, 500) // Actualizar cada 500ms
    }

    const calculateProgressPendingSend = (currentPending) => {
        // Si no hay pendientes, completado
        if (currentPending === 0) {
            if (totalInicial.current > 0) {
                // Animar hacia 100% si no estamos ya ahí
                const currentProgressValue = Math.round(
                    ((totalInicial.current - ultimosPendientes.current) /
                        totalInicial.current) *
                        100,
                )
                animateProgressTo(100, currentProgressValue)
                // Resetear después de mostrar completado
                setTimeout(() => {
                    totalInicial.current = 0
                    ultimosPendientes.current = 0
                    setProgressTotalModal(0)
                    setProgress(0)
                    setHavePendingData(false)
                }, 6000)
            }
            return
        }

        // Primera vez o nuevo trabajo significativo
        if (
            totalInicial.current === 0 ||
            currentPending > totalInicial.current + 5
        ) {
            totalInicial.current = currentPending
            ultimosPendientes.current = currentPending
            setProgressTotalModal(currentPending)
            setProgress(0)
            return
        }

        // Calcular progreso usando el total inicial persistente
        const itemsEnviados = Math.max(0, totalInicial.current - currentPending)
        const targetPercentage = Math.round(
            (itemsEnviados / totalInicial.current) * 100,
        )

        // Solo actualizar si cambió significativamente
        if (currentPending !== ultimosPendientes.current) {
            const currentProgressValue = Math.round(
                ((totalInicial.current - ultimosPendientes.current) /
                    totalInicial.current) *
                    100,
            )

            // Animar el progreso gradualmente
            animateProgressTo(targetPercentage, currentProgressValue)

            ultimosPendientes.current = currentPending
            // console.log('📊 Progreso objetivo:', itemsEnviados, '/', totalInicial.current, '=', targetPercentage + '%')
        }
    }

    const sendPendingConnectionMain = async () => {
        // Validar que no se esté ejecutando ya
        // console.log('-------------------------sendPendingConnectionMain------------------------- => ', new Date())
        // console.log('isExecutingSendPending => ', isExecutingSendPending.current)
        if (isExecutingSendPending.current) {
            // console.log('⚠️ sendPendingConnectionMain ya se está ejecutando, saltando esta ejecución')
            return
        }

        // Marcar como en ejecución
        isExecutingSendPending.current = true

        try {
            const hasConnection = await validateConnectionNetwork(true)

            let pendings = await UserServices.get_pendings_conections()
            // console.log('🚀🚀🚀🚀🚀 ~ sendPendingConnectionMain ~ pendings:', JSON.stringify(pendings))

            const totalPending = getCantDataPending(pendings.results)

            // Calcular progreso usando solo el valor actual
            calculateProgressPendingSend(totalPending)

            //
            // await cleanupLocalStores()
            // Actualizar el estado
            setPendingsSend(totalPending)

            if (pendings && pendings.status == 0) {
                setHavePendingData(true)
                if (currentIntervalRef.current != TIME_INTERVAL_FAST) {
                    currentIntervalRef.current = TIME_INTERVAL_FAST
                }
                if (hasConnection) {
                    // console.log('310 - 🚀 ~ sendPendingConnectionMain ~ hasConnection:', hasConnection, pendings.status)
                    // console.log("🚀 ~ sendPendingConnectionMain ~ pendings:", pendings)
                    const authToken =
                        (await getAuthToken('tabs_send_pendings')) || ''
                    try {
                        await sendActivitiesDistributorPending(authToken)
                        await sendSurveyPending(authToken)
                        await sendTrackings(authToken)
                        await sendPendingConnection() // pendientes de agenda
                    } catch (error) {
                        const errorMessage = error?.message || String(error)
                        // Only log unexpected errors, not network errors (those are handled in individual functions)
                        if (
                            !errorMessage.includes('NetworkError') &&
                            !errorMessage.includes('network')
                        ) {
                            console.error(
                                'Error syncing pending data:',
                                errorMessage,
                            )
                        }
                    }
                }
            } else {
                setHavePendingData(false)
                if (currentIntervalRef.current != TIME_INTERVAL_SLOW) {
                    currentIntervalRef.current = TIME_INTERVAL_SLOW
                }
            }
        } catch (error) {
            console.log('🚀 ~ sendPendingConnection ~ error:', error)
        } finally {
            isExecutingSendPending.current = false
            // console.log('✅ sendPendingConnectionMain terminó, flag liberado')
        }
    }
    const sendSurveyPending = async (authToken) => {
        try {
            await PostsServices.get_all_surveys().then((results) => {
                //console.log("8888888888888888 ~ awaitPostsServices.get_all_surveys ~ results:", results)
                results.forEach((item) => {
                    const data = {
                        authToken: authToken,
                        post_id: item.post_id,
                        course_id: item.course_id,
                        survey_id: item._id,
                        answers: item.answers,
                    }
                    save_survey_request(data).then((result) => {
                        //console.log("99999999  ~ save_survey_request ~ result:", result)
                        if (result && result.status == 1) {
                            PostsServices.delete_survey_by_id(item._id)
                        }
                    })
                })
            })
        } catch (error) {
            console.log('🚀 ~ sendSurveyPending ~ error:', error)
        }
    }
    const sendTrackings = async (authToken) => {
        // const webSocketInstance = useWebSocket()
        try {
            // ✅ Validate connection before attempting to send
            const hasConnection = await validateConnectionNetwork(true)
            if (!hasConnection) {
                console.log(
                    '⚠️ sendTrackings: No internet connection, skipping tracking sync',
                )
                return
            }

            //cambiar cuando se quiera agrupar de a mas
            let getTrackings = await TrackingServices.getTrackings()
            // console.log('==============>>🚚 trackings a enviar pendientes------> ', getTrackings.length)

            if (getTrackings && getTrackings.length > 5) {
                //cambiar cuando se quiera agrupar de a mas
                //puedo enviarlos
                // let sendTrackings = ws.sendMessage(getTrackings, WEBSOCKET_TYPES.TRACKINGS, authToken)
                try {
                    // if (webSocketInstance) {
                    //     webSocketInstance
                    //         .send(getTrackings, WEBSOCKET_TYPES.TRACKINGS, authToken)
                    //         .then(() => {
                    //             // Eliminar los datos de seguimiento enviados correctamente del almacenamiento local
                    //             getTrackings.forEach(async (tracking) => {
                    //                 let deletePostFromLocal = await TrackingServices.deleteTrackingByIdFromLocal(tracking['_id'])
                    //             })
                    //             // Código que se ejecuta cuando los datos se envían correctamente
                    //         })
                    //         .catch((error) => {
                    //             console.error('Error al enviar los datos', error)
                    //             // Código que se ejecuta cuando ocurre un error al enviar los datos
                    //         })
                    // }
                } catch (error) {
                    console.error('Error en la operación del WebSocket', error)
                    // Código que se ejecuta cuando ocurre una excepción
                }

                let dataToSend = {
                    type: WEBSOCKET_TYPES.TRACKINGS,
                    data: getTrackings,
                }

                const { response } = await request_save_trackings({
                    authToken,
                    body: dataToSend,
                })

                await deleteTrackingsSend(response)
            }
        } catch (error) {
            console.error('sendTrackings => ', error)
        }
    }

    const deleteTrackingsSend = async (response) => {
        if (
            !response ||
            response?.status != 1 ||
            response?.trackinsCreates?.length == 0
        ) {
            return
        }

        const trackins = response?.trackinsCreates || []
        console.log('🚀 ~ deleteTrackingsSend ~ trackins:', trackins.length)

        if (trackins.length > 0) {
            for (const trackId of trackins) {
                await TrackingServices.deleteTrackingByIdFromLocal(trackId)
            }
        }
    }

    const sendActivitiesDistributorPending = async (authToken) => {
        try {
            const pendings =
                await schedulesServices.getActivitiesDistributorsPending()
            // console.log('🚀 ~ sendActivitiesDistributorPending ~ pendings:', pendings.length)
            if (pendings && pendings.length > 0) {
                for (const item of pendings) {
                    const data = {
                        authToken: authToken,
                        schedule_id: item.schedule_id,
                        checkin_id: item?.checkin_id || null,
                        activities: item.activities,
                    }

                    let send = await request_save_schedules_activities(data)
                    // console.log('🚀 ~ sendActivitiesDistributorPending ~ send:', JSON.stringify(send))
                    if (send && send.status === 1) {
                        // si se envio correctamente borro el registro..
                        const responseDelete =
                            await schedulesServices.deleteByIdActivitiesDistributorsPending(
                                item._id,
                            )
                        // console.log("🚀 ~ sendActivitiesDistributorPending ~ responseDelete:", responseDelete)
                    }
                }
            }
        } catch (error) {
            console.error('Error sending activities distributor pending:', error)
        }
    }

    useEffect(() => {
        const initialize = async () => {
            try {
                console.log('TabsNavigation - Inicializando...', Platform.OS)
                const deviceId = await getDeviceId()
                setDeviceId(deviceId)

                let token = token_notification || notification?.data
                console.log('TabsNavigation - Llamando get_access_token...')
                await get_access_token(deviceId, token)
                console.log('TabsNavigation - get_access_token completado')
                // console.log('Notification token:', token)

                //setIsLoading(false)
            } catch (error) {
                globalIsLoading = false
                setIsLoading(false)
                //alert(`error ${error}`)
                console.error('Error initialize TabsNavigation:', error)
            } finally {
                globalIsLoading = false
                setIsLoading(false)
                updateLocation()
            }
        }

        initialize()

        // Listener para detectar login y resetear loader
        const authListener = Hub.listen('auth', (data) => {
            const event = data?.payload?.event
            console.log('🔐 [TabsNavigation] Auth event:', event)

            if (event === 'signedIn') {
                console.log(
                    '🔐 [TabsNavigation] User signed in - resetting loader states',
                )
                // Resetear flags globales
                globalFirstBatchReady = false
                globalFirstScreenReady = false
                globalIsLoading = true

                // Activar loader
                setIsLoading(true)
                setFirstBatchReady(false)
                setFirstScreenReady(false)
                setHasLocalPosts(false)
            }
        })

        // Escuchar readiness del muro para mantener/ocultar loader de forma global
        const onFirstBatch = () => {
            console.log('🔔 Received app:firstBatchReady')
            globalFirstBatchReady = true
            globalIsLoading = false
            setFirstBatchReady(true)
            setIsLoading(false)
        }
        const onFullySynced = () => {
            // Si quieres, podrías esperar el fully sync para ocultar del todo;
            // de momento, usamos firstBatchReady para no bloquear la UI.
            console.log('🔔 Received app:fullySynced')
        }
        eventEmitter.on('app:firstBatchReady', onFirstBatch)
        eventEmitter.on('app:fullySynced', onFullySynced)
        const onFirstScreen = () => {
            console.log('🔔 Received app:firstScreenReady')
            globalFirstScreenReady = true
            globalIsLoading = false
            setFirstScreenReady(true)
            setIsLoading(false)
        }
        eventEmitter.on('app:firstScreenReady', onFirstScreen)
        const onHasLocalPosts = () => {
            try {
                console.log('🔔 Received app:hasLocalPosts')
            } catch {}
            setHasLocalPosts(true)
        }
        eventEmitter.on('app:hasLocalPosts', onHasLocalPosts)
        // Deadline para no bloquear indefinidamente si el footer no llega
        const t = setTimeout(() => setFooterDeadlineExpired(true), 8000)
        return () => {
            authListener() // Cleanup del Hub listener
            eventEmitter.removeListener('app:firstBatchReady', onFirstBatch)
            eventEmitter.removeListener('app:fullySynced', onFullySynced)
            eventEmitter.removeListener('app:hasLocalPosts', onHasLocalPosts)
            eventEmitter.removeListener('app:firstScreenReady', onFirstScreen)
            clearTimeout(t)
        }
    }, [notification, expoPushToken])

    useEffect(() => {
        const restartFlagAssestsPS = async () => {
            await StorageAdapter.setItem(
                ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES,
                'false',
            )
            await StorageAdapter.setItem(
                ASYNC_STORAGE_KEYS.UNZIP_IN_PROGRESS_PS,
                'false',
            )
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.SAVE_PS_FORMS, 'false')
        }

        restartFlagAssestsPS()

        const pending = setInterval(() => {
            sendPendingConnectionMain()
        }, 30000)
        downloadPendingPS()
        return () => clearInterval(pending)
    }, [])
    const expoConfig = Constants.expoConfig || { slug: '' }
    const portfolioIcon =
        expoConfig.slug === 'dots' || expoConfig.slug === 'branca-one'
            ? 'grid'
            : 'briefcase'

    const tabsScreens = {
        PostsList: {
            id: 1,
            screen: PostsList,
            icon: (focused) => (
                <AntDesign name='rocket' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'rocket' : 'rocket-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'get_wall',
            trackingCategory: 'posts',
            routeName: 'PostsList',
        },
        LearningHome: {
            id: 2,
            screen: LearningHome,
            icon: (focused) => (
                <Feather name='book' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'school' : 'school-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'get_training_home',
            trackingCategory: 'learning_courses',
            routeName: 'LearningHome',
        },
        Schedule: {
            id: 3,
            screen: Schedule,
            icon: (focused) => (
                <Feather name='map-pin' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'location' : 'location-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'get_all_store',
            trackingCategory: 'schedule_stores',
            routeName: 'Schedule',
        },
        CreateScheduleModerator: {
            id: 4,
            screen: CreateScheduleModerator,
            icon: (focused) => (
                <Feather name='map-pin' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'location' : 'location-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'schedule_moderator',
            trackingCategory: 'schedule_moderator',
            routeName: 'CreateScheduleModerator',
        },
        Portfolio: {
            id: 5,
            screen: Portfolio,
            icon: (focused) => (
                <Feather name={portfolioIcon} size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'briefcase' : 'briefcase-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'ecommerce_products',
            trackingCategory: 'ecommerce_brands',
            routeName: 'Portfolio',
        },
        BenefitsHome: {
            id: 6,
            screen: BenefitsHome,
            icon: (focused) => (
                <Feather name='award' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'gift' : 'gift-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'get_benefits',
            trackingCategory: 'benefit_vouchers',
            routeName: 'BenefitsHome',
        },
        Schedule: {
            id: 7,
            screen: Schedule,
            icon: (focused) => (
                <Feather name='map-pin' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'location' : 'location-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'get_all_stores',
            trackingCategory: 'schedule_stores',
            routeName: 'Schedule',
        },
        WiseScreen: {
            id: 8,
            screen: WiseScreen,
            icon: (focused) => (
                <Feather name='file' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'document' : 'document-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'ejecutions_audits',
            trackingCategory: 'ejecutions_audits',
            routeName: 'WiseScreen',
        },
        MyAdvance: {
            id: 9,
            screen: MyAdvance,
            icon: (focused) => (
                <Feather name='trending-up' size={24} color={setColor(focused)} />
                //<Ionicons name={focused ? 'document' : 'document-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'advance_users',
            trackingCategory: 'advance_users',
            routeName: 'MyAdvance',
        },
        ScheduleDistributor: {
            id: 10,
            screen: ScheduleDistributor,
            icon: (focused) => (
                <Feather name='map-pin' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'location' : 'location-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'ScheduleDistributor',
            trackingCategory: 'ScheduleDistributor',
            routeName: 'ScheduleDistributor',
        },
        VouchersScreen: {
            id: 11,
            screen: VouchersScreen,
            icon: (focused) => (
                <Feather name='camera' size={24} color={setColor(focused)} />
                // <Ionicons name={focused ? 'location' : 'location-outline'} size={24} color={setColor(focused)} />
            ),
            trackingAction: 'get_voucher',
            trackingCategory: 'benefit_vouchers',
            routeName: 'VouchersScreen',
        },
        Trivia: {
            id: 12,
            screen: TriviaScreen,
            icon: (focused) => (
                <Feather name='star' size={24} color={setColor(focused)} />
            ),
            trackingAction: 'trivia',
            trackingCategory: 'trivia',
            routeName: 'Trivia',
        },
        Gamification: {
            id: 12,
            screen: Gamification,
            icon: (focused) => (
                <Ionicons
                    name='game-controller-outline'
                    size={28}
                    color={setColor(focused)}
                />
            ),
            trackingAction: '',
            trackingCategory: '',
            routeName: 'Gamification',
        },
        Ranking: {
            id: 13,
            screen: RankingScreen,
            icon: (focused) => (
                <Image
                    source={require('../../../assets/footer_RankingIcon.png')}
                    style={{ width: 24, height: 24, tintColor: setColor(focused) }}
                />
            ),
            trackingAction: '',
            trackingCategory: '',
            routeName: 'Ranking',
        },
        Doti: {
            id: 14,
            screen: DotiScreen,
            icon: (focused) => (
                <DotiFooter styles={{ marginBottom: 20 }} isActive={isFocused} />
            ),
            trackingAction: '',
            trackingCategory: '',
            routeName: 'Doti',
        },
        Profile: {
            id: 15,
            screen: ProfileScreen,
            icon: (focused) => (
                <Feather name='settings' size={24} color={setColor(focused)} />
            ),
            trackingAction: '',
            trackingCategory: '',
            routeName: 'Profile',
        },
        Dashboard: {
            id: 16,
            screen: DashboardWeb,
            icon: (focused) => (
                <Ionicons name='stats-chart' size={24} color={setColor(focused)} />
            ),
            trackingAction: '',
            trackingCategory: '',
            routeName: 'DashBoard',
        },
        link: {
            id: 17,
            screen: DashboardWeb,
            icon: (focused) => (
                <Ionicons name='stats-chart' size={24} color={setColor(focused)} />
            ),
            routeName: 'Link',
        },
        Advances: {
            id: 18,
            screen: AdvancesScreen,
            icon: (focused) => (
                <Feather name='trending-up' size={24} color={setColor(focused)} />
            ),
            trackingAction: 'advances',
            trackingCategory: 'advances',
            routeName: 'Advances',
        },
    }

    // --- NUEVO: Sin fallback hardcodeado ---
    // Filtrar ítems válidos reales (se reubicó arriba la definición de footerVisibleItems luego del useEffect)

    // Redefinir función renderTab simple (solo si existe realmente)
    const renderTab = (label) => {
        if (!tabsScreens[label] && !label.startsWith('link')) return null
        const exists = footerVisibleItems.some(
            (item) =>
                item.label === label && item.nav == false && item.section == false,
        )

        if (!exists) return null
        const component = tabsScreens[label]

        if (label.startsWith('link')) {
            // console.log('Renderizando link personalizado:', label)
            const item = footerVisibleItems.find((i) => i.label === label)
            const url = item?.link || ''

            let iconName = 'football-outline'
            if (label.toLowerCase() === 'link2') {
                iconName = 'ticket-outline'
            }
            return (
                <Tab.Screen
                    key={label}
                    name={label}
                    component={View}
                    listeners={{
                        tabPress: async (e) => {
                            e.preventDefault()
                            if (url === '') return console.log('No hay ruta valida')

                            Linking.openURL(url)
                        },
                    }}
                    options={{
                        tabBarIcon: () => (
                            <Ionicons
                                name={iconName}
                                size={24}
                                color={setColor(false)}
                            />
                        ),
                        unmountOnBlur: true,
                    }}
                />
            )
        }
        return (
            <Tab.Screen
                key={component.id}
                name={label}
                component={component.screen}
                listeners={{
                    tabPress: () => {
                        handleClickTracking(
                            component.trackingAction,
                            component.trackingCategory,
                        )
                        setCurrentFooterRoute(component.routeName)
                    },
                }}
                options={{
                    tabBarIcon: ({ focused }) => component.icon(focused),
                    unmountOnBlur: true,
                }}
            />
        )
    }

    const translateY = useRef(new Animated.Value(0)).current // Estado animado
    const androidFooterHeight = 45 // 55
    const [footerHeight, setFooterHeight] = useState(
        platformSelect({
            ios: 82,
            android: androidFooterHeight,
            default: 55,
        }),
    )
    const toggleFooterVisibility = (visible) => {
        Animated.timing(translateY, {
            toValue: visible ? 0 : 100, // Desliza hacia abajo o muestra
            duration: 600,
            useNativeDriver: true, // Mejora el rendimiento
        }).start()

        // En web evitar height=0 (causaba crash del Tab.Navigator). Ocultamos sólo con translateY.
        const targetHeight = platformSelect({
            ios: 82,
            android: androidFooterHeight,
            default: 55,
        })
        if (Platform.OS === 'web') {
            setFooterHeight(targetHeight)
        } else {
            setFooterHeight(visible ? targetHeight : 0)
        }
    }

    useEffect(() => {
        const onStart = () => toggleFooterVisibility(false)
        const onEnd = () => toggleFooterVisibility(true)

        eventEmitter.on('hideFooter', onStart)
        eventEmitter.on('showFooter', onEnd)

        return () => {
            eventEmitter.removeListener('hideFooter', onStart)
            eventEmitter.removeListener('showFooter', onEnd)

            // Limpiar animación de progreso si existe
            if (progressAnimation.current) {
                clearInterval(progressAnimation.current)
            }
        }
    }, [])

    const footerVisibleItems = useMemo(() => {
        return Array.isArray(footer_app)
            ? footer_app
                  .filter((item) => {
                      const acceptedFalse = (v) =>
                          v === false ||
                          v === 0 ||
                          v === '0' ||
                          v === 'false' ||
                          v === null ||
                          v === undefined
                      const isValid =
                          item &&
                          item.label &&
                          acceptedFalse(item.nav) &&
                          acceptedFalse(item.section)
                      if (!isValid) {
                          //   console.log('[TabsNavigation][footer filter] descartado item', {
                          //       label: item && item.label,
                          //       nav: item && item.nav,
                          //       section: item && item.section,
                          //   })
                      }
                      return isValid
                  })
                  .orderFooterAndCenterDoti('label', 'Doti')
            : []
    }, [footer_app])

    useEffect(() => {
        if (footerVisibleItems.length > 0) {
            let hasProfile = footerVisibleItems.some(
                (item) => item.label === 'Profile',
            )
            setShowProfileNav(!hasProfile)
        }
    }, [footerVisibleItems])
    // console.log('Footervisible ITEN S)))=> ,', footer_app.orderFooterAndCenterDoti('label', 'Doti'))
    const shouldShowFooter = footerVisibleItems.length > 0
    // Evitar deadlock: siempre montamos el Tab.Navigator y mostramos Loader como overlay mientras no esté listo.
    const overlayActive =
        isLoading ||
        !(
            firstScreenReady ||
            firstBatchReady ||
            hasLocalPosts ||
            footerDeadlineExpired
        )

    // Web: bypass total del Tab.Navigator para evitar crash de BottomTabView (reading 'frame').
    // La navegación en web la maneja el layout específico (WebSidebar / NavigationStack).
    if (Platform.OS === 'web') {
        // console.log('[TabsNavigation][web] Bypass total -> render PostsList directly, tabs handled by Web layout')
        // HUD de depuración opcional: activar con localStorage.__web_debug_feed = '1'
        let showWebDebug = false
        try {
            if (typeof window !== 'undefined') {
                showWebDebug =
                    window.localStorage?.getItem?.('__web_debug_feed') === '1'
            }
        } catch {}
        return (
            <>
                <PostsList useCssColumnsMasonry />
                {overlayActive && (
                    <View
                        pointerEvents='none'
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                        }}
                    >
                        <Loader />
                        {footerDeadlineExpired && (
                            <View
                                style={{
                                    position: 'absolute',
                                    bottom: 60,
                                    left: 16,
                                    right: 16,
                                    padding: 12,
                                    borderRadius: 8,
                                    backgroundColor: themes.colors.alert + '22',
                                    borderWidth: 1,
                                    borderColor: themes.colors.alert + '55',
                                }}
                            >
                                <Text
                                    style={{
                                        fontSize: 12,
                                        color: themes.colors.alert,
                                        fontWeight: '600',
                                        textAlign: 'center',
                                    }}
                                >
                                    No se recibieron accesos del footer aún. Verifica
                                    conexión o reintenta.
                                </Text>
                            </View>
                        )}
                    </View>
                )}
                {showWebDebug && (
                    <View
                        pointerEvents='none'
                        style={{
                            position: 'fixed',
                            bottom: 8,
                            right: 8,
                            backgroundColor: 'rgba(0,0,0,0.6)',
                            paddingVertical: 6,
                            paddingHorizontal: 10,
                            borderRadius: 6,
                            zIndex: 99999,
                        }}
                    >
                        <Text style={{ color: 'white', fontSize: 11 }}>
                            batch:{String(firstBatchReady)} screen:
                            {String(firstScreenReady)} items:
                            {footerVisibleItems.length}
                        </Text>
                        <Text style={{ color: 'white', fontSize: 11 }}>
                            overlay:{String(overlayActive)} loading:
                            {String(isLoading)} deadline:
                            {String(footerDeadlineExpired)}
                        </Text>
                    </View>
                )}
            </>
        )
    }

    // console.log('[TabsNavigation][render] about to render Tab.Navigator footerVisibleItems=', footerVisibleItems.length)
    return safeRender(
        <>
            {(() => {
                try {
                    return (
                        <Tab.Navigator
                            screenOptions={{
                                headerShown: false,
                                tabBarStyle: [
                                    { ...styles.footerApp },
                                    { paddingVertical: 10 },
                                    {
                                        display:
                                            footerRoute === 'Gamification'
                                                ? 'none'
                                                : 'flex',
                                    },

                                    // { transform: [{ translateY }] },
                                    //{ height: footerHeight, minHeight: Platform.OS === 'web' ? 1 : undefined },
                                    //{
                                    //     marginBottom: Platform.select({
                                    //         android: footerHeight === 0 ? -1 : 0,
                                    //         ios: footerHeight === 0 ? -50 : 0,
                                    //         default: 0,
                                    //         borderWidth: 0,
                                    //     }),
                                    // },
                                ], // Agregar backgroundColor para que cambie de color el footer
                                tabBarShowLabel: false,
                                tabBarItemStyle: {
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                },
                                tabBarIconStyle: {
                                    marginTop: 5, // evitá que el ícono quede muy arriba
                                },
                                lazy: true,
                            }}
                        >
                            {shouldShowFooter ? (
                                footerVisibleItems.map((tabButton) =>
                                    renderTab(tabButton.label),
                                )
                            ) : (
                                <Tab.Screen
                                    key={'1'}
                                    name={'label'}
                                    component={PostsList}
                                    listeners={{
                                        tabPress: (event) => {
                                            handleClickTracking('get_wall', 'users')
                                        },
                                    }}
                                    options={{
                                        // Ocultamos el icono mientras no haya footer listo para evitar parpadeo
                                        tabBarIcon: () => null,
                                    }}
                                />
                            )}
                        </Tab.Navigator>
                    )
                } catch (err) {
                    console.error(
                        '[TabsNavigation][render] Tab.Navigator crash:',
                        err,
                    )
                    if (Platform.OS === 'web') {
                        return (
                            <View style={{ padding: 16 }}>
                                <Text>{`Problema al inicializar navegación de tabs (web). Reintentando…`}</Text>
                            </View>
                        )
                    }
                    return null
                }
            })()}
            {overlayActive && (
                <View
                    pointerEvents='none'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                    }}
                >
                    <Loader />
                    {!shouldShowFooter && (
                        <View
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                flexDirection: 'row',
                                padding: 12,
                                gap: 12,
                                backgroundColor: 'rgba(0,0,0,0.05)',
                            }}
                        >
                            {[1, 2, 3, 4].map((i) => (
                                <View
                                    key={i}
                                    style={{
                                        flex: 1,
                                        height: 40,
                                        borderRadius: 10,
                                        backgroundColor: 'rgba(0,0,0,0.08)',
                                        overflow: 'hidden',
                                    }}
                                />
                            ))}
                        </View>
                    )}
                    {footerDeadlineExpired && !shouldShowFooter && (
                        <View
                            style={{
                                position: 'absolute',
                                bottom: 60,
                                left: 16,
                                right: 16,
                                padding: 12,
                                borderRadius: 8,
                                backgroundColor: themes.colors.alert + '22',
                                borderWidth: 1,
                                borderColor: themes.colors.alert + '55',
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: 12,
                                    color: themes.colors.alert,
                                    fontWeight: '600',
                                    textAlign: 'center',
                                }}
                            >
                                No se recibieron accesos del footer aún. Verifica
                                conexión o reintenta.
                            </Text>
                        </View>
                    )}
                </View>
            )}
        </>,
    )
}

export default MyTabs
